export function isTypedObject(what) {
    return typeof what === "object" && what !== null && "getTypes" in what;
}
//# sourceMappingURL=typed-object.js.map